export const TABLE_DATA = [
  ["Mufti", "individual", "22%", 7993],
  ["Bengal", "individual", "89%", 245],
  ["Pongo", "team", "78%", 45],
  ["Saman", "individual", "12%", 45],
  ["Charles Rb", "individual", "8%", 215],
  ["Cornelius Py", "team", "32%", 785],
];

export const TABLE_COLUMNS = ["name", "individual/team", "shares", "amount"];
